module.exports = __webpack_public_path__ + "static/media/Tornax-OT-2100.5eab5fd8.png";